import type { RouteObject } from 'react-router';
import { TicketEventsPage } from './pages/TicketEventsPage';
import { TicketEventDetailPage } from './pages/TicketEventDetailPage';

export const ticketRoutes: RouteObject[] = [
  { path: 'ticket-events', element: <TicketEventsPage /> },
  { path: 'ticket-events/:slug', element: <TicketEventDetailPage /> },
];
